import React from 'react'
import _ from 'lodash'
import ModalWrapper from 'components/modals/ModalWrapper'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PaymentComponent from 'components/payment/PaymentComponent'
const styles = theme => ({})
const getTitle = transaction => {
  let title = 'Paiement'
  switch (transaction.type) {
    case 'POOL':
      return `${title} ${transaction.pool.table.name}`
    case 'BAR':
      return `${title} ${transaction.bar.name}`
    case 'CUSTOMER':
      return `${title} ${transaction.customer.name}`
    default:
      return title
  }
}
class PaymentModal extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    hist: PropTypes.object,
    user: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    cancelPaymentModal: PropTypes.func,
    paymentTypes: PropTypes.array.isRequired,
    addPayment: PropTypes.func.isRequired,
    removePayment: PropTypes.func.isRequired,
    closeTransaction: PropTypes.func
  }
  state = {
    okDisabled: true
  }
  handleCancel = () => {
    if (this.props.cancelPaymentModal) {
      this.props.cancelPaymentModal(this.props.transaction)
    }
  }
  handleValidate = () => {
    if (this.props.closeTransaction) {
      this.props.closeTransaction(this.props.transaction)
      this.props.history.replace('/home')
    }
  }

  updateState(nextProps = this.props) {
    let paymentsOk = false
    let sync = true
    if (nextProps.transaction && nextProps.transaction.paymentReady) {
      const payments = (nextProps.transaction || {}).payments || {}
      const products = (nextProps.transaction || {}).products || {}
      Object.keys(products).map(key => {
        if (!products[key].id_sale_product_detail) {
          sync = false
        }
        return null
      })
      let paymentAmount = 0
      Object.keys(payments).map(key => {
        paymentAmount += Number(payments[key].amount)
        if (!payments[key].payment_detail_id) {
          sync = false
        }
        return null
      })

      if (
        Number(nextProps.transaction.total) > 0 &&
        _.round(paymentAmount, 2) >=
          _.round(Number(nextProps.transaction.total), 2)
      ) {
        paymentsOk = true
      } else if (
        Number(nextProps.transaction.total) === 0 &&
        paymentAmount === 0 &&
        (nextProps.transaction.products || nextProps.transaction.pool)
      ) {
        sync = false
      }
    }
    if (sync && paymentsOk) {
      this.setState({ okDisabled: false })
    } else {
      this.setState({ okDisabled: true })
    }
  }
  componentDidMount() {
    this.updateState()
  }
  componentWillReceiveProps(nextProps) {
    this.updateState(nextProps)
  }
  render() {
    const { transaction, paymentTypes } = this.props
    if (!transaction) return null
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleValidate}
        onCancel={this.handleCancel}
        title={getTitle(transaction)}
        okText="Clôturer"
        cancelText={this.props.closeTransaction ? 'Retour' : 'Fermer'}
        showCancel
        okDisabled={this.state.okDisabled}
        showOk={!!this.props.closeTransaction}>
        <PaymentComponent
          user={this.props.user}
          transaction={transaction}
          hist={this.props.hist}
          paymentTypes={paymentTypes}
          addPayment={this.props.addPayment}
          removePayment={this.props.removePayment}
        />
      </ModalWrapper>
    )
  }
}

export default withRouter(withStyles(styles)(PaymentModal))



// WEBPACK FOOTER //
// ./src/components/modals/client/PaymentModal.js